import { PaginationRequestParams } from "./../common/mixins/pagination";
import { HTTPClient } from "@/common/HTTPClient";
import axios, { Method } from "axios";

const httpClient = (
  method: Method = "get",
  endpoint = "/",
  body = {},
  headers = {},
  apiUrl = process.env.VUE_APP_BRIDGE_API_URL,
  options = {}
) => {
  const url = `${apiUrl}/${endpoint}`;
  const data = body;
  const queryName = method === "GET" ? "params" : "data";

  const api = axios.create({
    baseURL: url,
  });

  api.interceptors.request.use((config) => {
    // GET TOKEN
    const token = localStorage.getItem("mycloud_order_service::accessToken");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  });

  const res: any = api.request({
    method,
    url,
    [queryName]: data,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...headers,
    },
    ...options,
  });

  res.catch((error: any) => {
    if (error.response) {
      if (error.response.status === 401) {
        // Unauthorized

        if (error.response?.data.message) {
          console.log(error.response.data.message);
        }
      }
    }
  });

  return Promise.resolve(res);
};

export class ApiBridgeSystemClient {
  constructor(private httpClient: HTTPClient) {}

  public async getToken() {
    /*eslint-disable */
    const params = {
      grant_type: "password",
      email: "admin@admin.com",
      password: "admin1234",
    };

    /*eslint-enable */

    const { data } = await httpClient("POST", "oauth2/token", params);

    localStorage.setItem(
      "mycloud_order_service::accessToken",
      data.data.access_token
    );
  }

  public async getOrdersBridgeSystem(
    params: PaginationRequestParams,
    status: string,
    fromDate: Date,
    toDate: Date,
    search?: string,
    shopId?: number,
    key?: string,
    orderType?: string
  ): Promise<any> {
    await this.getToken();
    const result = await httpClient("GET", "bridges/reservedorder/bulk", {
      search,
      fromDate,
      toDate,
      shopId,
      status,
      key,
      orderType,
      limit: params.limit,
      page: params.page,
    });
    return result.data;
  }

  public async postApproveOrderBridgeSystem(params: number): Promise<any> {
    await this.getToken();
    const result = await httpClient("POST", "bridges/approved/bulk", {
      numberOfOrders: +params,
    });
    return result.data;
  }

  public async getShop() {
    await this.getToken();
    const result = await httpClient("GET", "bridges/shops");
    return result.data;
  }
}
